











































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, SurveyActionType, Product, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getAnalysisHistoricalCentres } from "@/services";

import { date } from "quasar";

@Component
export default class HistoricalCentresAnalysis extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  historicalCentres: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";

  async mounted() {
    try {
      this.historicalCentres = await getAnalysisHistoricalCentres();
      this.setSurveyType(SurveyType.ANALYSIS_OLDTOWN);
      this.filteredData = this.historicalCentres;
    } catch (error) {
      console.log(error);
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.historicalCentres.filter(historicalCentre =>
        historicalCentre.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.historicalCentres;
    }
  }

  openShowAttractiveness(historicalCentre: Product) {
    this.$router
      .push(
        `survey/${SurveyType.ANALYSIS_OLDTOWN}/${
          historicalCentre.surveys.length > 0 ? historicalCentre.surveys[0].id : historicalCentre.id
        }/${historicalCentre.surveys.length === 0 ? SurveyActionType.NEW : SurveyActionType.UPDATE}`,
      )
      .catch(error => console.log(error));
  }

  getAttractivenessDate(historicalCentre: Product) {
    if (historicalCentre.surveys.length > 0) {
      return date.formatDate(historicalCentre.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
    ];
  }
}
